import { ApplicationId } from "@1games-ru/region-shared/dist/enums/tablet/applicationd-id";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "@/core/store";

export interface PcState {
  isShow: boolean;
  appsList: ApplicationId[];
  activeApp: ApplicationId;
  isVisible: boolean;
}

const initialState = {
  isShow: false,
  appsList: [ApplicationId.Business],
  activeApp: ApplicationId.Business,
  isVisible: true,
};

const pcSlice = createSlice({
  name: "pcSlice",
  initialState,
  reducers: {
    setIsShow: (state, action: PayloadAction<boolean>) => {
      state.isShow = action.payload;
    },
    setAppsList: (state, action: PayloadAction<ApplicationId[]>) => {
      state.appsList = action.payload;
    },
    setActiveApp: (state, action: PayloadAction<ApplicationId>) => {
      state.activeApp = action.payload;
    },
    setIsVisible: (state, action: PayloadAction<boolean>) => {
      state.isVisible = action.payload;
    },
  },
});

export const pcIsShow = (state: RootState) => state.pc.isShow;
export const pcAppsList = (state: RootState) => state.pc.appsList;
export const pcActiveApp = (state: RootState) => state.pc.activeApp;
export const pcIsVisible = (state: RootState) => state.pc.isVisible;

export const pcReducer = pcSlice.reducer;
export const { setIsShow, setAppsList, setActiveApp, setIsVisible } = pcSlice.actions;
